import { CreateSchedule } from "@coworker/apprestructured/src/task-management/types/Schedule";
import { httpClient } from "@coworker/http-client";
import { Task } from "@coworker/apprestructured/src/task-management/types/Task";

// Returns the first task in the schedule
export async function createSchedule(createSchedule: CreateSchedule) {
  return httpClient.tasks.post<Task>("/schedules", { body: createSchedule });
}
